
export const typesAuhtButton = {
    landing: 'landing',
    login: 'login',
    register: 'register',
    restore: 'restore',
    logout: 'logout'
}